import { put, call, takeLeading, select } from 'redux-saga/effects'
import { trace } from '../services/common'
import { types } from '../types/config'
import * as actions from '../actions/config'
import * as services from '../services/config'
import { selectAllowedDomains } from '../selectors/config'

export function* getDataStreamAllowedDomainsSaga() {
  try {
    const existingDomains = yield select(selectAllowedDomains)
    if (!existingDomains.length) {
      const domains = yield call(services.getDataStreamAllowedDomains)
      yield put(actions.getDataStreamAllowedDomainsSuccessAction(domains))
    } else {
      yield put(actions.getDataStreamAllowedDomainsCancelAction())
    }
  } catch (err) {
    trace(err)
    yield put(actions.getDataStreamAllowedDomainsFailureAction(err.message))
  }
}

export function* configWatcher() {
  yield takeLeading(
    types.GET_DATASREAM_ALLOWED_DOMAINS__START,
    getDataStreamAllowedDomainsSaga
  )
}
